import {
  Alert,
  Autocomplete,
  Button,
  FormControl,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { cloneDeep, debounce } from "lodash";
import { useTranslation } from "react-i18next";
import {
  decryptString,
  encryptString,
  stringifyJSONAttributes,
  stringToBooleanConversion,
} from "../../../utils/utilFunctions";
import { api } from "../../../redux/api";
import { useDispatch, useSelector } from "react-redux";
import { isInValidInput, sanitizeInput } from "../../../utils/validate";
import ErrorModal from "../../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import SmartPasswordField from "../../../commonComponents/SmartPasswordField";
import GetDataAdvanceProperties from "../../ItemProperties/WorkflowProperties/Common/GetDataAdvanceProperties";
import _ from "lodash";
import { MoreHorizOutlined } from "@mui/icons-material";
import WorkflowSessionModal from "../../ItemProperties/WorkflowSessionModal";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../redux/slices/treeSlice";

const File = ({
  connectionDetails,
  handleBodyContent,
  direction,
  screen,
  useConnection,
  disableControl,
  repoPDC,
  fileMaskName,
}) => {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData?.[parentScreen] ?? {});
  const currentTab = rightTree?.currentTab;
  const selectedNode = rightTree?.tree?.[currentTab]?.selectedNode;
  const { templateHeader } = useSelector(
    (state) => state.treeData?.workflow?.rightTree?.tree ?? {}
  );
  const dispatch = useDispatch();
  const [fileDirectory, setFileDirectory] = useState("");
  const [maskName, setMaskName] = useState("");
  const [deleteFile, setDeleteFile] = useState(false);
  const [decompression, setDecompression] = useState(false);
  const [showDecompressionDir, setShowDecompressionDir] = useState(false);
  const [decompressionDir, setDecompressionDir] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [content, setContent] = useState(null);
  const [processDuplicateFiles, setProcessDuplicateFiles] = useState(false);
  const [enableDistributedFileProcessing, setEnableDistributedFileProcessing] =
    useState(false);
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
  });
  const [valueLabel, setValueLabel] = useState("");
  const [showCheckbox, setShowCheckbox] = useState(false);
  // Destination
  const [fileName, setFileName] = useState("");
  const [compression, setCompression] = useState(false);
  const [appendFile, setAppendFile] = useState(false);
  const [appendArchive, setAppendArchive] = useState(false);
  const [compressionList, setCompressionList] = useState([]);
  const [compressionType, setCompressionType] = useState("");
  const [fileNameZip, setFileNameZip] = useState("");
  const [showDestinationPassword, setShowDestinationPassword] = useState(false);
  const [destinationPassword, setDestinationPassword] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState({
    mssg: "",
    type: "success",
    isOpen: false,
  });
  const translatedData = rightTree?.tree?.[rightTree?.currentTab]?.translatedData || [];

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  };

  const debouncedContentUpdate = debounce(handleBodyContent, 300);

  const onInputChange = (name, value, cb) => {
    if (cb) {
      cb();
      return;
    }
    if (screen === "GET_DATA" || screen === "SEND_DATA") {
      setContent({ [name]: value });
    }
    else setContent((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const handleBlur = () => {
    const res = isInValidInput(fileName);
    if (res.inValid) {
      setErrorModal(true);
      setErrorMessage(res.message);
    } else {
      setErrorModal(false);
      setErrorMessage(res.message);
    }
  };

  const inputConverter = () => {
    const sanitizeResult = sanitizeInput(fileName);
    onInputChange("FILENAME", sanitizeResult);
    setFileName(sanitizeResult);
    setErrorModal(false);
    setErrorMessage("");
  };
  const valuesHandler = (value) => {
    if (workflowMappings[valueLabel]) {
      const { stateSetter, key } = workflowMappings[valueLabel];
      let encryptedValue = value;
      if(key === 'ZIP_PASSWORD'){
        encryptedValue = encryptString(value, process.env.REACT_APP_SECRET_KEY2)
      }
      stateSetter(value);
      onInputChange(key, encryptedValue);
    }
  };
  const handleDecompressionChange = (checked) => {
    setDecompression(checked);

    if (checked) {
      onInputChange("ZIP", "ZIP");
    } 
    else {
      setShowDecompressionDir(false);
      setDecompressionDir("");
      setShowPassword(false);
      setPassword("");
      if(screen && screen === 'GET_DATA'){
        onInputChange('add',{ZIP: null, SPECIFY_DECOMPRESSION_DIRECTORY:'FALSE', DECOMPRESSION_DIRECTORY: null, USE_ZIP_PASSWORD:'FALSE',ZIP_PASSWORD: null})
      } else {
        onInputChange("ZIP", "");
        onInputChange("SPECIFY_DECOMPRESSION_DIRECTORY",stringifyJSONAttributes(false));
        onInputChange("DECOMPRESSION_DIRECTORY", "");
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", "");
      }
    }
  }
  const handleCompressionChange = (checked) => {
    setCompression(checked);
    if(checked){
      onInputChange("ZIP", "ZIP");
    }
    else{
      setCompressionType("ZIP");
      setFileNameZip("");
      setShowDestinationPassword(false);
      setDestinationPassword("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{ZIP: null, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null, FILE_NAME_WITHIN_ZIP: null})
      } else {
        onInputChange("ZIP", ""); 
        onInputChange("FILE_NAME_WITHIN_ZIP", "");
        onInputChange("ZIP_PASSWORD", "");
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
      }
    }
  }

  const handleCompressionTypeChange = (value) => {
    setCompressionType(value);
    if(["GZ", "TAR", "TGZ"].includes(value)){
      setShowDestinationPassword(false);
      setDestinationPassword("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{ZIP: value, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null})
      } else {
        onInputChange("ZIP", value);
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", "");
      }
    } else {
      onInputChange("ZIP", value);
    }
  }
  // Helper function to calculate font weight
  const getFontWeight = (
    control,
    currentValue,
    connectionDetails,
    useConnection
  ) => {
    if(control === 'COMPRESSION_TYPE' && !repoPDC?.hasOwnProperty('COMPRESSION_TYPE') && currentValue === 'ZIP'){
      return "normal"
    }
    return repoPDC?.[control] !== currentValue && useConnection === "preDefined"
      ? "bold"
      : "normal";
  };
  const fontWeights = useMemo(() => {
    return {
      FILE_LOCATION: getFontWeight(
        "FILE_LOCATION",
        fileDirectory,
        connectionDetails,
        useConnection
      ),
      FILENAMEMASK: getFontWeight(
        "FILENAMEMASK",
        maskName,
        connectionDetails,
        useConnection
      ),
      DECOMPRESSION_DIRECTORY: getFontWeight(
        "DECOMPRESSION_DIRECTORY",
        decompressionDir,
        connectionDetails,
        useConnection
      ),
      PASSWORD: getFontWeight(
        "ZIP_PASSWORD",
        password,
        connectionDetails,
        useConnection
      ),
      FILENAME: getFontWeight(
        "FILENAME",
        fileName,
        connectionDetails,
        useConnection
      ),
      FILENAME_WITHIN_ZIP: getFontWeight(
        "FILE_NAME_WITHIN_ZIP",
        fileNameZip,
        connectionDetails,
        useConnection
      ),
      COMPRESSION_PASSWORD: getFontWeight(
        "ZIP_PASSWORD",
        destinationPassword,
        connectionDetails,
        useConnection
      ),
      COMPRESSION_TYPE: getFontWeight(
        "COMPRESSION_TYPE",
        compressionType,
        connectionDetails,
        useConnection
      ),
      // Add more fields as needed
    };
  }, [
    fileDirectory,
    maskName,
    decompressionDir,
    password,
    destinationPassword,
    fileNameZip,
    compressionType,
    connectionDetails,
    useConnection,
  ]);
  useEffect(() => {
    if (!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
  }, [content]);

  function removeSourceWfItemFromSendData() {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if(obj?.ICON_DISPLAY !== "SEND_DATA") return;

      if(obj?.hasOwnProperty("INBOUND_ID") && obj?.INBOUND_ID === selectedNode?.ID) {
        delete obj?.INBOUND_ID;
        delete obj?.INBOUND_NAME;
        delete obj?.SOURCE_WFITEM;
        delete obj?.SOURCE_WFITEM_ID;
      }
    })

    dispatch(treeActions.setNewRightTreeTranslatedData({
      screen: parentScreen,
      type: rightTree.currentTab,
      data: updatedData
    }))
  }

  useEffect(() => {
    setFileDirectory(connectionDetails?.FILE_LOCATION || "");
    setMaskName(connectionDetails?.FILENAMEMASK || "");
    if (connectionDetails?.DELETE) {
      if (stringToBooleanConversion(connectionDetails?.DELETE))
        setDeleteFile(false);
      else setDeleteFile(true);
    } else setDeleteFile(false);
    if (connectionDetails?.ZIP === "ZIP" || connectionDetails?.hasOwnProperty('ZIP')) {
      setDecompression(true);
      setCompression(true);
    } else {
      setDecompression(false);
      setCompression(false);
    }
    if (
      (connectionDetails?.DECOMPRESSION_DIRECTORY &&
        connectionDetails?.DECOMPRESSION_DIRECTORY?.length !== 0) ||
      stringToBooleanConversion(
        connectionDetails?.SPECIFY_DECOMPRESSION_DIRECTORY
      )
    )
      setShowDecompressionDir(true);
    else setShowDecompressionDir(false);
    setDecompressionDir(connectionDetails?.DECOMPRESSION_DIRECTORY || "");
    setShowPassword(
      stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD)
    );
    setPassword(connectionDetails?.ZIP_PASSWORD ? (decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2)) : "");
    // setCompression(stringToBooleanConversion(connectionDetails?.COMPRESSION));
    setAppendFile(stringToBooleanConversion(connectionDetails?.APPEND_FILE));
    // setAppendArchive( stringToBooleanConversion(connectionDetails?.APPEND_ARCHIVE));
    setAppendArchive( stringToBooleanConversion(connectionDetails?.APPEND_FILE));

    setCompressionType(connectionDetails?.ZIP || "ZIP");
    setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || "");
    setProcessDuplicateFiles(connectionDetails?.DO_NOT_PROCESS_DUPLICATE_FILES ==='TRUE' || false)
    setEnableDistributedFileProcessing(connectionDetails?.ENABLE_DISTRIBUTED_FILE_PROC === 'TRUE' || false)
    if (direction === "OUT") {
      setFileName(connectionDetails?.FILENAME || "");
      setShowDestinationPassword(
        stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD)
      );
      setDestinationPassword(connectionDetails?.ZIP_PASSWORD ? (decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2)) : "");
    }
    setContent({ ...connectionDetails });
  }, [connectionDetails]);

  useEffect(() => {
    if (direction === "OUT") {
      dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
        if (res?.data?.current_state === "SUCCESS") {
          const types = Object.values(res?.data?.data)?.map(
            (item) => item?.TYPE
          );
          setCompressionList(types);
        }
        if (res?.data?.current_state === "ERROR") {
          setShowAlert({
            mssg: res?.data?.message,
            isOpen: true,
            type: "error",
          });
        }
      });
    }
  }, [direction]);

  useEffect(() => {
    if (templateHeader && templateHeader?.hasOwnProperty("SERVICE") && templateHeader?.SERVICE?.NAME === selectedNode?.title && templateHeader?.SERVICE?.ENABLED === "TRUE") {
      setShowCheckbox(true);
    } else {
      setShowCheckbox(false);
    }
  }, [templateHeader]);
  
  const workflowMappings = {
    [t("LBL_FILE_DIR")]: {
      stateSetter: setFileDirectory,
      key: "FILE_LOCATION",
      value: fileDirectory,
    },
    [t("LBL_FILE_NAME_MASK")]: {
      stateSetter: setMaskName,
      key: "FILENAMEMASK",
      value: maskName,
    },
    [t("LBL_FILE_NAME")]: {
      stateSetter: setFileName,
      key: "FILENAME",
      value: fileName,
    },
    [t("LBL_DECOMPRESS_DIRECTORY")]: {
      stateSetter: setDecompressionDir,
      key: "DECOMPRESSION_DIRECTORY",
      value: decompressionDir,
    },
    [t("LBL_WS_PASSWORD")]: {
      stateSetter: setPassword,
      key: "ZIP_PASSWORD",
      value: password,
    },
    [t("LBL_PASSWORD")]: {
      stateSetter: setDestinationPassword,
      key: "ZIP_PASSWORD",
      value: destinationPassword,
    },
    [t("FILE_NAME_WITHIN_ZIP")]: {
      stateSetter: setFileNameZip,
      key: "FILE_NAME_WITHIN_ZIP",
      value: fileNameZip,
    },
  };

  return (
    <>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_FILE_DIR")}
            type="text"
            disabled={disableControl || false}
            value={fileDirectory || ""}
            sx={{ input: { fontWeight: fontWeights.FILE_LOCATION } }}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setFileDirectory(e.target.value);
            }}
            className={"width-100"}
            name={"FILE_LOCATION"}
            autoComplete="off"
          />
        </FormControl>
        {screen && (screen === "GET_DATA" || screen === "SEND_DATA") && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_FILE_DIR"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>

      {direction === "IN" && (
        <>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_FILE_NAME_MASK")}
                type="text"
                disabled={disableControl ||  false}
                value={maskName || ""}
                sx={{ input: { fontWeight: fontWeights.FILENAMEMASK } }}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setMaskName(e.target.value);
                }}
                className={"width-100"}
                name={"FILENAMEMASK"}
                autoComplete="off"
              />
            </FormControl>
            {screen && screen === "GET_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_FILE_NAME_MASK"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>

          {screen && screen === "GET_DATA" && (
            <GetDataAdvanceProperties
              updateAdvProp={handleBodyContent}
              disableControl={disableControl}
            />
          )}
          <div>
            {(screen !== "GET_DATA" || !showCheckbox) && (
              <TPCheckbox
                label={t("BTN_DO_NOT_DELETE")}
                checked={deleteFile}
                disabled={disableControl || false}
                handleCheck={(checked) => {
                  onInputChange("DELETE", stringifyJSONAttributes(!checked));
                  setDeleteFile(checked);
                }}
              />
            )}
            {screen && screen === "GET_DATA" && (
              <>
                {showCheckbox && (
                  <TPCheckbox
                    label={t("DO_NOT_PROCESS_DUPLICATE_FILES")}
                    checked={processDuplicateFiles}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                      onInputChange(
                        "DO_NOT_PROCESS_DUPLICATE_FILES",
                        stringifyJSONAttributes(checked)
                      );
                      setProcessDuplicateFiles(checked);
                    }}
                  />
                )}

                {selectedNode?.RUN_ON_SERVER === "LBL_RUN_ON_PRIMARY" &&
                  showCheckbox && (
                    <TPCheckbox
                      label={t("LBL_ENABLE_DISTRIBUTED_FILE_PROCESSING")}
                      checked={enableDistributedFileProcessing}
                      disabled={disableControl || false}
                      handleCheck={(checked) => {
                        onInputChange(
                          "ENABLE_DISTRIBUTED_FILE_PROC",
                          stringifyJSONAttributes(checked)
                        );
                        setEnableDistributedFileProcessing(checked);
                      }}
                    />
                  )}
              </>
            )}
          </div>
          <div>
            <TPCheckbox
              label={t("BTN_USE_ZIP_DECOMPRESS")}
              id='fileDecompression'
              checked={decompression}
              disabled={disableControl || false}
              handleCheck={(checked) => {handleDecompressionChange(checked)}}
            />
          </div>
          {decompression && (
            <>
              <div>
                <TPCheckbox
                  label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
                  checked={showDecompressionDir}
                  disabled={disableControl || false}
                  handleCheck={(checked) => {
                    checked && removeSourceWfItemFromSendData();
                    onInputChange(
                      "SPECIFY_DECOMPRESSION_DIRECTORY",
                      stringifyJSONAttributes(checked)
                    );
                    setShowDecompressionDir(checked);
                    if (!checked) {
                      if (screen === "GET_DATA") {
                        onInputChange(null, null, () => {
                          setContent({add: {
                            "SPECIFY_DECOMPRESSION_DIRECTORY": "FALSE",
                            "DECOMPRESSION_DIRECTORY": null
                          }})
                        })
                      }else{
                        onInputChange("DECOMPRESSION_DIRECTORY", null);
                      }
                      setDecompressionDir("");
                    }
                  }}
                />
              </div>
              {showDecompressionDir && (
                <div style={{ display: "flex", gap: "4px" }}>
                  <FormControl className="width-100" size="small">
                    <TextField
                      variant="outlined"
                      size="small"
                      disabled={disableControl || false}
                      label={t("LBL_DECOMPRESS_DIRECTORY")}
                      type="text"
                      value={decompressionDir || ""}
                      sx={{
                        input: {
                          fontWeight: fontWeights.DECOMPRESSION_DIRECTORY,
                        },
                      }}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setDecompressionDir(e.target.value);
                      }}
                      className={"width-100"}
                      name={"DECOMPRESSION_DIRECTORY"}
                      autoComplete="off"
                    />
                  </FormControl>
                  {screen && screen === "GET_DATA" && (
                    <Button
                      size="small"
                      disabled={disableControl || false}
                      variant="outlined"
                      onClick={() => {
                        setValueLabel(t("LBL_DECOMPRESS_DIRECTORY"));
                        setWorkflowSessionModal({
                          open: true,
                          isFirstTime: true,
                        });
                      }}
                      sx={{ width: "40px", minWidth: "40px" }}>
                      <MoreHorizOutlined fontSize="small" />
                    </Button>
                  )}
                </div>
              )}
              <div>
                <TPCheckbox
                  label={t("LBL_WS_PASSWORD")}
                  checked={showPassword}
                  disabled={disableControl || false}
                  handleCheck={(checked) => {
                    onInputChange(
                      "USE_ZIP_PASSWORD",
                      stringifyJSONAttributes(checked)
                    );
                    setShowPassword(checked);
                    if (!checked) {
                      setPassword("");
                      onInputChange("ZIP_PASSWORD", "");
                    }
                  }}
                />
              </div>
              {showPassword && (
                <div style={{ display: 'flex', gap: "4px" }}>
                  <SmartPasswordField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_PASSWORD")}
                    disabled={disableControl || false}
                    value={password || ""}
                    inputProps={{ style: { fontWeight: fontWeights.PASSWORD } }}
                    onChange={(e) => {
                      const { value } = e.target;
                      onInputChange(
                        e.target.name,
                        encryptString(value, process.env.REACT_APP_SECRET_KEY2)
                      );
                      setPassword(e.target.value);
                    }}
                    className={"width-100"}
                    name={"ZIP_PASSWORD"}
                    autoComplete="off"
                  />
                  {screen && screen === "GET_DATA" && (
                    <Button
                      size="small"
                      disabled={disableControl || false}
                      variant="outlined"
                      onClick={() => {
                        setValueLabel(t("LBL_WS_PASSWORD"));
                        setWorkflowSessionModal({
                          open: true,
                          isFirstTime: true,
                        });
                      }}
                      sx={{ width: "40px", minWidth: "40px" }}>
                      <MoreHorizOutlined fontSize="small" />
                    </Button>
                  )}
                </div>
              )}
            </>
          )}
        </>
      )}

      {direction === "OUT" && (
        <>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_FILE_NAME")}
                type="text"
                disabled={fileMaskName?.includes('*') || fileMaskName?.includes('?') || fileMaskName?.includes(":") || disableControl || false}
                value={fileName || ""}
                sx={{ input: { fontWeight: fontWeights.FILENAME } }}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setFileName(e.target.value);
                }}
                onBlur={handleBlur}
                className={"width-100"}
                name={"FILENAME"}
                autoComplete="off"
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={fileMaskName?.includes('*') || fileMaskName?.includes('?') || fileMaskName?.includes(":") || disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_FILE_NAME"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div className="flex flex-wrap">
            <TPCheckbox
              label={t("BTN_USE_ZIP_COMPRESS")}
              checked={compression}
              disabled={disableControl || false}
              handleCheck={(checked) => {
                handleCompressionChange(checked);                
              }}
            />
            <TPCheckbox
              label={t("BTN_APPEND_ARCHIVE")}
              checked={appendArchive}
              disabled={fileMaskName?.includes('*') || fileMaskName?.includes('?') || disableControl || false}
              handleCheck={(checked) => {
                onInputChange("APPEND_FILE", stringifyJSONAttributes(checked));
                setAppendArchive(checked);
              }}
            />
          </div>
          {compression && (
            <>
              <Autocomplete
                disablePortal
                options={compressionList}
                getOptionLabel={(option) => option}
                value={compressionType}
                disabled={disableControl || false}
                sx={{ maxHeight: 300, input: { fontWeight: fontWeights.COMPRESSION_TYPE } }}
                onChange={(e, value) => {
                  handleCompressionTypeChange(value);
                  
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("LBL_COMPRESSION_TYPE")}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleCompressionTypeChange(value);
                    }}
                    variant="outlined"
                    size="small"
                    name={"COMPRESSION_TYPE"}
                    autoComplete="off"
                  />
                )}
              />
              <div style={{ display: "flex", gap: "4px" }}>
                <FormControl className="width-100" size="small">
                  <TextField
                    variant="outlined"
                    size="small"
                    disabled={disableControl || false}
                    label={t("FILE_NAME_WITHIN_ZIP")}
                    type="text"
                    value={fileNameZip || ""}
                    sx={{ input: { fontWeight: fontWeights.FILENAME_WITHIN_ZIP } }}
                    onChange={(e) => {
                      onInputChange(e.target.name, e.target.value);
                      setFileNameZip(e.target.value);
                    }}
                    className={"width-100"}
                    name={"FILE_NAME_WITHIN_ZIP"}
                    autoComplete="off"
                  />
                </FormControl>
                {screen === "SEND_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("FILE_NAME_WITHIN_ZIP"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>
              {["JAR", "RAR", "ZIP"].includes(compressionType) && (
                <>
                  <div>
                    <TPCheckbox
                      label={t("LBL_WS_PASSWORD")}
                      checked={showDestinationPassword}
                      disabled={disableControl || false}
                      handleCheck={(checked) => {
                        onInputChange(
                          "USE_ZIP_PASSWORD",
                          stringifyJSONAttributes(checked)
                        );
                        setShowDestinationPassword(checked);
                        if (!checked) {
                          onInputChange("ZIP_PASSWORD", "");
                          setDestinationPassword("");
                        }
                      }}
                    />
                  </div>
                  {showDestinationPassword && (
                    <div style={{ display: "flex", gap: "4px" }}>
                      <SmartPasswordField
                        variant="outlined"
                        size="small"
                        label={t("LBL_PASSWORD")}
                        disabled={disableControl || false}
                        value={destinationPassword || ""}
                        inputProps={{ style: { fontWeight: fontWeights.COMPRESSION_PASSWORD } }}
                        onChange={(e) => {
                          onInputChange(e.target.name,  encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2));
                          setDestinationPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"ZIP_PASSWORD"}
                        autoComplete="off"
                      />
                      {screen === "SEND_DATA" && (
                        <Button
                          size="small"
                          disabled={disableControl || false}
                          variant="outlined"
                          onClick={() => {
                            setValueLabel(t("LBL_PASSWORD"));
                            setWorkflowSessionModal({
                              open: true,
                              isFirstTime: true,
                            });
                          }}>
                          <MoreHorizOutlined fontSize="small" />
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      <ErrorModal
        errorModal={errorModal}
        setErrorModal={() => setErrorModal(false)}
        errorMessage={errorMessage}
        OkHandler={inputConverter}
      />
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
      <WorkflowSessionModal
        valueLabel={valueLabel}
        showAccountData={true}
        showCallingWorkflow={true}
        showSystemData={true}
        showWorkflowSession={true}
        showDateAndTime={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={workflowMappings[valueLabel]?.value}
        valuesHandler={(value) => {
          valuesHandler(value);
        }}
        inputType={valueLabel === t("LBL_WS_PASSWORD") || valueLabel === t("LBL_PASSWORD") ? "password" : "text"}
        specialPasswordField={valueLabel === t("LBL_WS_PASSWORD") || valueLabel === t("LBL_PASSWORD")}
      />
    </>
  );
}

export default File